import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/pos-api";
import { Button } from "@/components/ui/button";
import ProductCopyPanel from "@/components/ProductCopyPanel";
import BranchUnitSyncPanel from "@/components/BranchUnitSyncPanel";

const initial = { name: "", subdomain: "", admin_email: "", admin_password: "" };
export default function Tenants() {
  const [tenants, setTenants] = useState([]);
  const [form, setForm] = useState(initial);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [created, setCreated] = useState(null);
  async function load() {
    setLoading(true);
    try { setTenants((await api.get("/master/tenants")).data); }
    catch (e) { setError(apiError(e)); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);
  async function submit(e) {
    e.preventDefault(); setBusy(true); setError(""); setCreated(null);
    try {
      const { data } = await api.post("/master/tenants", form, { timeout: 120000 });
      setCreated(data); setForm(initial); setShow(false);
      window.dispatchEvent(new Event("pos-tenants-updated"));
      await load();
    } catch (e) { setError(apiError(e)); }
    finally { setBusy(false); }
  }
  return <section className="flex-1 overflow-auto p-4 md:p-8 space-y-5">
    <div className="flex flex-wrap justify-between items-center gap-3">
      <div><h1 className="text-2xl font-bold">Kelola Tenant</h1><p className="text-sm text-ui-muted">Buat toko dengan subdomain dan akun admin sendiri.</p></div>
      <Button onClick={() => { setShow(true); setCreated(null); }} data-testid="create-tenant-button">Tambah tenant</Button>
    </div>
    {error && <div role="alert" className="rounded-lg bg-danger-soft text-danger-readable p-3">{error}<button className="underline ml-3" onClick={() => { setError(""); load(); }}>Muat ulang daftar</button></div>}
    {created && <div role="status" className="rounded-lg bg-brand-soft text-brand-readable p-4">
      <strong>{created.name} berhasil dibuat.</strong><p><a className="underline" href={`https://${created.host}`} target="_blank" rel="noreferrer">https://{created.host}</a></p>
      <p>Admin: {created.admin_email}. Gunakan password yang baru Anda tetapkan.</p>
    </div>}
    {show && <form onSubmit={submit} className="bg-ui-card border rounded-xl p-5 space-y-4 max-w-2xl">
      <h2 className="font-semibold text-lg">Tenant baru</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <label className="text-sm">Nama toko<input id="tenant-name" required maxLength={100} disabled={busy} className="block border rounded-lg p-2 w-full mt-1" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></label>
        <label className="text-sm">Subdomain<input id="tenant-subdomain" required pattern="[a-z]([a-z0-9-]{0,30}[a-z0-9])?" maxLength={32} disabled={busy} className="block border rounded-lg p-2 w-full mt-1" placeholder="sm3" value={form.subdomain} onChange={e => setForm({ ...form, subdomain: e.target.value.toLowerCase() })} /><span className="text-xs text-ui-muted">{form.subdomain || "sm3"}.masivi.id</span></label>
        <label className="text-sm">Email admin<input id="tenant-email" type="email" required autoComplete="off" disabled={busy} className="block border rounded-lg p-2 w-full mt-1" value={form.admin_email} onChange={e => setForm({ ...form, admin_email: e.target.value })} /></label>
        <label className="text-sm">Password admin<input id="tenant-password" type="password" required minLength={12} maxLength={72} autoComplete="new-password" disabled={busy} className="block border rounded-lg p-2 w-full mt-1" value={form.admin_password} onChange={e => setForm({ ...form, admin_password: e.target.value })} /><span className="text-xs text-ui-muted">Minimal 12 karakter, maksimal 72 byte.</span></label>
      </div>
      <p className="text-sm text-ui-muted">Database dan akun admin disiapkan otomatis. Subdomain menggunakan DNS dan HTTPS wildcard yang sudah aktif.</p>
      <div className="flex gap-2"><Button type="submit" disabled={busy}>{busy ? "Menyiapkan tenant…" : "Buat tenant"}</Button><Button type="button" variant="outline" disabled={busy} onClick={() => { setShow(false); setForm(initial); }}>Batal</Button></div>
    </form>}
    {loading && <p role="status">Memuat daftar tenant…</p>}
    <div className="grid lg:grid-cols-2 gap-4">{tenants.map(t => <article key={t.id} className="bg-ui-card border rounded-xl p-5 space-y-2">
      <h2 className="font-semibold text-lg">{t.name}</h2><a className="text-brand-readable underline break-all" href={`https://${t.host}`} target="_blank" rel="noreferrer">{t.host}</a>
      <p className="text-sm text-ui-muted break-all">Admin awal: {t.admin_email}</p>
      <Button variant="outline" onClick={() => { sessionStorage.setItem("pos_master_tenant", t.id); window.location.assign("/pos"); }}>Lihat data toko</Button>
    </article>)}</div>
    {!loading && tenants.length === 0 && <p>Belum ada tenant. Tambahkan toko pertama Anda.</p>}
    {!loading && tenants.length > 1 && <>
      <ProductCopyPanel tenants={tenants} />
      <BranchUnitSyncPanel />
    </>}
  </section>;
}
